/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneArticleBodytext from 'base/components/standalone/ArticleBodytext';

export const DynamicStandaloneArticleBodytext = StandaloneArticleBodytext;
export type DynamicStandaloneArticleBodytextProps = PropsFromComponent<typeof StandaloneArticleBodytext>;

export const DynamicStandaloneArticleBodytextWith = (extras: DynamicStandaloneExtras): typeof StandaloneArticleBodytext => {
    return function DynamicStandaloneArticleBodytext(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ArticleBodytext');
        return <StandaloneArticleBodytext {...mergeProps({ options: { theme } }, props)} />;
    }
}